import React, { Component } from 'react';
import { Paper, Button, CircularProgress } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import * as actions from '../../actions';
class MultiAddressPanel extends Component {
    constructor(props) {
        super();
        this.state = {
            selectedAddress: {},
            selected: props.selectedKeys ? props.selectedKeys : []
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.userData.addresses.length !==
            this.props.userData.addresses.length
        ) {
            this.setState({ data: this.props.userData.addresses });
        }
    }
    selectAll = event => {
        if (event.target.checked) {
            this.setState(
                {
                    selected: this.props.userData.addresses.map(n => n.key)
                },
                () => {
                    this.props.setBookingAddress(this.state.selected);
                }
            );
            return;
        }
        this.setState({ selected: [] }, () => {
            this.props.setBookingAddress(this.state.selected);
        });
    };
    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        this.setState({ selected: newSelected }, () => {
            this.props.setBookingAddress(this.state.selected);
        });
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;
    render() {
        const { selected } = this.state;
        const { userData } = this.props;
        const rowCount = userData.addresses.length;
        const numSelected = selected.length;
        if (!this.state.selectedAddress) {
            return (
                <div className="container">
                    <Paper>
                        <CircularProgress />
                    </Paper>
                </div>
            );
        }

        return (
            <div className="main-panel">
                <div>
                    <h5 className="my-3">
                        <FormattedMessage
                            id="address.choosetitle"
                            defaultMessage="Choose Address"
                        />
                    </h5>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => this.props.addNewAddress()}
                    >
                        <FormattedMessage
                            id="address.addnew"
                            defaultMessage="Add New"
                        />
                    </Button>
                    <div className="row">
                        <Checkbox
                            checked={numSelected === rowCount}
                            onChange={event => this.selectAll(event)}
                        />
                        <p style={{ color: '#000000' }}>
                            <FormattedMessage
                                id="address.selectall"
                                defaultMessage="Select All"
                            />
                        </p>

                        {/* <Button
                                variant="outlined"
                                color="primary"
                                size="sm"
                                onClick={this.props.addNewAddress}
                            >
                                Add Address
                            </Button> */}
                    </div>
                </div>
                {userData.addresses.map((address, index) => {
                    const isSelected = this.isSelected(address.key);
                    return (
                        <div className="row" key={address.key}>
                            <Checkbox
                                onClick={event =>
                                    this.handleClick(event, address.key)
                                }
                                checked={isSelected}
                            />

                            <p>
                                {address.name}, {address.phone},{' '}
                                {address.address_line1}
                            </p>
                        </div>
                    );
                })}
            </div>
        );
    }
}
const mapStateToProps = ({ auth }) => {
    return { userData: auth.userData };
};

const composedComponent = compose(
    withTheme(),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(MultiAddressPanel);



// WEBPACK FOOTER //
// ./src/components/Providers/MultiAddressPanel.jsx